import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: []
})
export class PreguntasFrecuentesComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="Preguntas frecuentes | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Preguntas frecuentes | Sinuberase",
  		description: "Encuentra las respuestas a las preguntas más frecuentes acerca de Sinuberase y todas sus presentaciones. Desde precio y dosis recomendada hasta dónde comprar el producto",
  		slug: "Preguntas-frecuentes"
  	})

  	this.seo.closeMenu();
  }

}
